// app/components/common/sections/ProductSection.tsx
"use client";

import Link from "next/link";
import { Button } from "../../shadcn/button";
import { ChevronRight } from "lucide-react";
import CountdownTimer from "../CountdownTimer";
import ProductSwiper from "../../elements/swipers/ProductSwiper";
import { Product } from "@/app/lib/features/product/product.types";
import { SectionCountdown } from "@/app/lib/features/home/home.types";
import { trackSectionClick } from "@/app/lib/tracking/interactions";
import { useTrackView } from "@/app/hooks/useTrackView";

interface ProductSectionProps {
  sectionId?: number;
  title: string;
  icon?: string;
  products: Product[];
  linkUrl?: string;
  linkText?: string;
  countdown?: SectionCountdown;
  viewAllSlug?: string;
  showViewAll?: boolean;
  maxSlidesPerView?: 4 | 6;
  priorityCount?: number;
}

const ProductSection = ({
  sectionId,
  title,
  icon,
  products,
  linkUrl,
  linkText = "Tümünü Gör",
  countdown,
  viewAllSlug,
  showViewAll = true,
  maxSlidesPerView = 6,
  priorityCount,
}: ProductSectionProps) => {
  const trackRef = useTrackView("section", sectionId);

  if (!products || products.length === 0) {
    return <></>;
  }

  return (
    <section ref={trackRef} className="bg-linear-to-b from-muted border border-muted to-white p-2 sm:py-4 px-[3px] rounded-md">
      <div className="flex items-center justify-between mb-2 sm:mb-3">
        <div className="flex items-center gap-1 sm:gap-2">
          <h2 className="text-base sm:text-xl font-medium flex items-center gap-2">
            {icon && <span className="text-xl">{icon}</span>}
            {title}
          </h2>
          {/* ends_at kontrolü şart: countdown nesnesi gelip ends_at'in null
              olduğu section'lar var, o durumda sıfırlanmış bir sayaç basmak
              yerine hiç gösterme. */}
          {countdown?.ends_at != null && (
            <CountdownTimer endTime={countdown.ends_at} size="md" />
          )}
        </div>

        {linkUrl && (
          <Button
            variant="link"
            asChild
            className="text-sm sm:text-lg p-0 sm:p-2"
          >
            <Link href={linkUrl} onClick={() => { if (sectionId) trackSectionClick(sectionId); }}>
              {linkText}
              <ChevronRight className="w-4 h-4 sm:w-5 sm:h-5" />
            </Link>
          </Button>
        )}
      </div>

      <ProductSwiper
        products={products}
        sectionId={sectionId}
        viewAllSlug={viewAllSlug}
        showViewAll={showViewAll}
        maxSlidesPerView={maxSlidesPerView}
        priorityCount={priorityCount}
      />
    </section>
  );
};

export default ProductSection;